import React, { useEffect, useState } from "react";

interface PartyCelebrationProps {
  show: boolean;
  onComplete: () => void;
}

interface EmojiParticle {
  id: number;
  left: number;
  animationDelay: number;
  animationDuration: number;
  fontSize: number;
}

export default function PartyCelebration({ show, onComplete }: PartyCelebrationProps) {
  const [particles, setParticles] = useState<EmojiParticle[]>([]);

  useEffect(() => {
    if (show) {
      // Generate random emoji particles
      const newParticles: EmojiParticle[] = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        left: Math.random() * 100, // Random position from 0% to 100%
        animationDelay: Math.random() * 2, // Stagger animations up to 2s
        animationDuration: 1.5 + Math.random() * 1, // Duration between 1.5s to 2.5s
        fontSize: 2 + Math.random() * 3, // Size between 2rem to 5rem
      }));
      setParticles(newParticles);

      // Auto-complete after 5 seconds
      const timer = setTimeout(() => {
        onComplete();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 pointer-events-none overflow-hidden">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-white/20 backdrop-blur-sm animate-in fade-in duration-300" />
      
      {/* Party emojis */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute animate-party-fall"
          style={{
            left: `${particle.left}%`,
            animationDelay: `${particle.animationDelay}s`,
            animationDuration: `${particle.animationDuration}s`,
            fontSize: `${particle.fontSize}rem`,
            top: '-10%',
          }}
        >
          🎉
        </div>
      ))}
      
      {/* Celebration text */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center animate-in zoom-in duration-500 delay-200">
          <div className="text-6xl mb-4">🎉</div>
          <h2 className="text-4xl font-bold text-gray-800 mb-2">Project Activated!</h2>
          <p className="text-xl text-gray-600">Ready for claims management</p>
        </div>
      </div>
    </div>
  );
} 